module.exports = __webpack_public_path__ + "img/culture-banner.0630d5bc.png";